import React from "react";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { useParams } from "react-router";
import { PageNotFound } from "pages/PageNotFound";
import { PropertyView } from "properties/propertyPage/PropertyView";
import { useLoadingFromPromise } from "_common/loaders/useLoadingFromPromise";
import { propertiesBuyingStore } from "properties/_stores/propertiesBuyingStore";
import { propertiesRentingStore } from "properties/_stores/propertiesRentingStore";
import { isBuyingPage } from "_common/_utils/pageUtils";
import { useLocation } from "react-router-dom";
import { TPropertyListingMdl } from "properties/_models/PropertyMdl";

export function PropertyPage() {
    const { propertyAlias } = useParams();
    const location = useLocation();
    const propertyOrFetch = isBuyingPage(location.pathname)
        ? propertiesBuyingStore.getByAliasUrl(propertyAlias)
        : propertiesRentingStore.getByAliasUrl(propertyAlias);

    const { loading } = useLoadingFromPromise(
        propertyOrFetch && !("localized" in propertyOrFetch)
            ? (propertyOrFetch as Promise<{
                  data: TPropertyListingMdl;
                  response: Response;
              }>)
            : undefined,
    );
    if (!propertyOrFetch) return null;
    if ("localized" in propertyOrFetch) {
        return <PropertyView property={propertyOrFetch} />;
    }
    if (!loading) return null;
    return (
        <LoadableFromLoading
            loading={loading}
            renderer={(_status, error, value) => {
                if (error || !value || !value.data) {
                    return <PageNotFound />;
                }
                return <PropertyView property={value.data} />;
            }}
        />
    );
}
